
































import { Richtext } from 'storyblok-js-client';
import { ref, computed, defineComponent } from '@vue/composition-api';
import { FCButton } from '@fc/angie-ui';
import { IExperimentProps } from '~/components/storyblok/Experiment/types';

interface IFaq {
  _uid: string;
  component: string;
  question: string;
  answer: Richtext;
}

type PossibleComponentsList = (IFaq|IExperimentProps)[]

export interface IFaqsCollapsibleContainerProps {
  container: PossibleComponentsList;
}

export default defineComponent({
  name: 'FaqsCollapsibleContainer',
  inheritAttrs: false,
  components: {
    FCButton,
  },
  props: {
    container: {
      type: Array,
      required: true,
    },
  },
  setup(props: IFaqsCollapsibleContainerProps) {
    const { $store } = useNuxtApp();
    const components = ref<PossibleComponentsList>([]);
    const remainingFaqList = ref<PossibleComponentsList>([]);
    const showAll = ref(false);
    const isSubPriceVariant = computed(() => $store.getters.isExp_035_subPriceVariant);

    components.value = props?.container?.slice(0, 5) ?? [];
    remainingFaqList.value = (props?.container?.slice(5, props.container.length) ?? []).map(faq => {
      if (faq.codeId === 'Membership') {
        if (isSubPriceVariant.value) {
          // eslint-disable-next-line no-param-reassign
          faq.answer.content[0].content[0].text = faq.answer.content[0].content[0].text.replace('$39', '$44');
        }
        return faq;
      }
      return faq;
    });

    return {
      faqList: components,
      remainingFaqList,
      showAll,
      toggleShowAll: () => { showAll.value = !showAll.value; },
      getButtonCopy: computed(() => (showAll.value ? 'Show Less' : 'Show All')),
    };
  },
});
